// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Cari Takip',
  subtitle: 'Hesap yönetimi ve para birimi takibi',
  newAccount: 'Yeni Hesap',
  editAccount: 'Hesap Düzenle',
  accountName: 'Hesap Adı',
  accountNamePlaceholder: 'Örn: Nakit Kasa, Banka Hesabı',
  initialBalance: 'Başlangıç Bakiyesi',
  balance: 'Bakiye',
  account: 'Hesap',
  selectAccount: 'Hesap Seçin',
  allAccounts: 'Tüm Hesaplar',
  income: 'Giriş',
  expense: 'Çıkış',
  onlyIncome: 'Sadece Gelir',
  onlyExpense: 'Sadece Gider',
  timeBasis: 'Zaman Bazı',
  analysis: 'Analiz',
  details: 'Detaylar',
  month: 'Ay',
  year: 'Yıl',
  profitLoss: 'Kar/Zarar',
  transactionCount: 'İşlem Sayısı',
  transactions: 'İşlemler',
  newTransaction: 'Yeni İşlem',
  editTransaction: 'İşlem Düzenle',
  addTransaction: 'İşlem Ekle',
  transactionType: 'İşlem Tipi',
  incomeType: 'Giriş (Gelir)',
  expenseType: 'Çıkış (Gider)',
  descriptionPlaceholder: 'İşlem açıklaması...',
  convertCurrency: 'Para Çevir',
  sourceAccount: 'Kaynak Hesap',
  targetAccount: 'Hedef Hesap',
  sourceAmount: 'Kaynak Tutar',
  targetAmount: 'Hedef Tutar',
  exchangeRate: 'Çevirme Oranı',
  enterOneAmount: 'Kaynak veya hedef tutardan birini girin',
  convert: 'Çevir',
  create: 'Oluştur',
  unknown: 'Bilinmeyen',
  noAccounts: 'Henüz hesap yok',
  noAccountsDesc: 'Yeni hesap ekleyerek başlayın.',
  noTransactions: 'Henüz işlem yok',
  noTransactionsDesc: 'İşlem ekleyerek başlayın.',
  noDataForFilters: 'Seçilen filtreler için veri bulunamadı.',
  accountCreated: 'Hesap başarıyla oluşturuldu',
  accountUpdated: 'Hesap başarıyla güncellendi',
  accountDeleted: 'Hesap başarıyla silindi',
  transactionCreated: 'İşlem başarıyla eklendi',
  transactionUpdated: 'İşlem başarıyla güncellendi',
  transactionDeleted: 'İşlem başarıyla silindi',
  currencyConverted: 'Para birimi başarıyla çevrildi',
  fetchError: 'Veri getirme hatası',
  fetchErrorMsg: 'Veriler alınamadı',
  fillAccountFields: 'Lütfen hesap adı ve para birimi girin',
  fillAllFields: 'Lütfen tüm alanları doldurun',
  createAccountError: 'Hesap oluşturma hatası',
  createAccountErrorMsg: 'Hesap oluşturulamadı',
  updateAccountError: 'Hesap güncelleme hatası',
  updateAccountErrorMsg: 'Hesap güncellenemedi',
  deleteAccountError: 'Hesap silme hatası',
  deleteAccountErrorMsg: 'Hesap silinemedi',
  confirmDeleteAccount: 'Bu hesabı silmek istediğinizden emin misiniz?',
  createTransactionError: 'İşlem ekleme hatası',
  createTransactionErrorMsg: 'İşlem eklenemedi',
  updateTransactionError: 'İşlem güncelleme hatası',
  updateTransactionErrorMsg: 'İşlem güncellenemedi',
  deleteTransactionError: 'İşlem silme hatası',
  deleteTransactionErrorMsg: 'İşlem silinemedi',
  confirmDeleteTransaction: 'Bu işlemi silmek istediğinizden emin misiniz?',
  selectBothAccounts: 'Lütfen kaynak ve hedef hesapları seçin',
  enterValidRate: 'Lütfen geçerli bir çevirme oranı girin',
  enterAmount: 'Lütfen kaynak veya hedef tutardan birini girin',
  sourceAccountNotFound: 'Kaynak hesap bulunamadı',
  insufficientBalance: 'Yetersiz bakiye',
  convertErrorMsg: 'Para birimi çevrilemedi',
  needTwoAccounts: 'Para birimi çevirmek için en az 2 aktif hesap gerekli',
  goldRateNotFound: 'Altın kuru bulunamadı.',
  currencyRateNotFound: 'Kuru bulunamadı.',
  exchangeRateError: 'Kur bilgileri alınamadı'
};
